module.exports = "/assets/packs/images/352b71b6af5b72fe7904273e93a69201.png";